import styled from 'styled-components';

export const LiveCasinoNavbarDefaultBox = styled.div<{stickOffset: number;}>`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: ${props => props.theme.colors.background};
    font-size: 1rem;
    border-bottom: 1px solid ${props => props.theme.colors.boxBorderDark};
    position: sticky;
    top: ${({stickOffset}) => stickOffset + "px"};
    z-index: 100;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 0.85rem;
    }
`;
